
import React from "react";
import { Check } from "lucide-react";

interface InstructionCheckboxProps {
  children: React.ReactNode;
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

const InstructionCheckbox = ({ children, id, checked, onCheckedChange }: InstructionCheckboxProps) => {
  return (
    <li className="flex items-start gap-3">
      <button
        onClick={() => onCheckedChange(!checked)}
        className={`
          flex-shrink-0 mt-0.5 w-5 h-5 rounded border-2 transition-all duration-200 ease-in-out
          ${checked 
            ? 'bg-green-500 border-green-500' 
            : 'border-gray-300 dark:border-gray-600 hover:border-green-400'
          }
        `}
      >
        {checked && (
          <Check className="w-3 h-3 text-white m-0.5 animate-scale-in" />
        )}
      </button>
      <span className={`
        flex-1 transition-all duration-200 ease-in-out text-sm
        ${checked ? 'line-through text-muted-foreground' : ''}
      `}>
        {children}
      </span>
    </li>
  );
};

export default InstructionCheckbox;
